export default __webpack_public_path__ + "static/property-report-510efcc90e39101e28d247d99cb45b36.jpg";